import React, { useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import styled from 'styled-components';
import ko from 'date-fns/locale/ko';
import { startOfWeek, endOfWeek } from 'date-fns';

interface tabType {
  id: number;
  tab: string;
}

const dateTabContent = [
  {
    id: 0,
    tab: '월간',
  },
  {
    id: 1,
    tab: '주간',
  },
  {
    id: 2,
    tab: '일간',
  },
];

const useTabs = (initialTabs: tabType[]) => {
  const [contentIndex, setContentIndex] = useState<number>(0);

  const activateTab = (index: number) => {
    setContentIndex(index);
  };
  return {
    contentItem: initialTabs[contentIndex],
    contentChange: activateTab,
    activeIndex: contentIndex,
  };
};

const DateTab = ({
  year,
  month,
  setYear,
  setMonth,
  oneMonthAgo,
  startDate,
  endDate,
  oneDay,
  setStartDate,
  setEndDate,
  setTabIdx,
  setOneDay,
}: any) => {
  const userData = localStorage.getItem('user');
  const userType = userData ? JSON.parse(userData).user_type : null;
  const [highlightedDates, setHighlightedDates] = useState<any>();

  const { contentItem: dateContentItem, contentChange: dateContentChange } =
    useTabs(dateTabContent);

  const tabClick = (index: number) => {
    dateContentChange(index);
    setTabIdx(index);
  };

  return (
    <Style>
      <div className="dateTabWrap">
        {
          dateTabContent.map((section, index) => (
            <button
              key={'dateButtons-' + index.toString()}
              onClick={() => tabClick(index)}
              className={dateContentItem.id === section.id ? 'tab active' : 'tab'}>
              <h2>{section.tab}</h2>
            </button>
          ))}
        {dateContentItem.id === 0 && (
          <div className="calendarWrap">
            <label htmlFor="startDatePicker" className="calendarContainer">
              <ReactDatePicker
                selected={month ? new Date(year, month - 1) : null}
                onChange={(date) => {
                  if (date) {
                    setMonth(date.getMonth() + 1);
                    setYear(date.getFullYear());
                  }
                }}
                dateFormat="yyyy년 MM월"
                locale={ko}
                maxDate={oneMonthAgo}
                showMonthYearPicker
                onFocus={(e) => {
                  e.preventDefault();
                  e.target.blur();
                }}
                className="datePicker"
              />
            </label>
          </div>
        )}
        {dateContentItem.id === 1 && (
          <div>
            <ReactDatePicker
              selected={startDate}
              onChange={(date: any) => {
                if (date.getDay() === 1) {
                  setStartDate(date);
                  const endDate = new Date(date);
                  endDate.setDate(date.getDate() + 6);
                  setEndDate(endDate);

                  const weekDates = [];
                  for (let i = 0; i < 7; i++) {
                    const tempDate = new Date(date);
                    tempDate.setDate(date.getDate() + i);
                    weekDates.push(tempDate);
                  }
                  setHighlightedDates(weekDates);
                }
              }}
              dateFormat={`${startDate.getFullYear()}년 ${
                startDate.getMonth() + 1
              }월 ${startDate.getDate()}일 ~ ${endDate.getMonth() + 1}월 ${endDate.getDate()}일`}
              locale={ko}
              maxDate={new Date(new Date().setDate(new Date().getDate() - 6))}
              className="weekdatePicker"
              filterDate={(date) => date.getDay() === 1}
              highlightDates={highlightedDates}
            />
          </div>
        )}
        {dateContentItem.id === 2 && (
          <div>
            <ReactDatePicker
              selected={oneDay}
              onChange={(date) => {
                if (date) {
                  setOneDay(date);
                }
              }}
              dateFormat="yyyy년 MM월 dd일"
              locale={ko}
              maxDate={new Date()}
              showWeekNumbers
              className="datePicker"
            />
          </div>
        )}
      </div>
    </Style>
  );
};

export default DateTab;
const Style = styled.div`
  /* dateTabWrap */
  .dateTabWrap {
    display: flex;
    justify-content: flex-start;
    gap: 10px;

    button {
      padding: 8px 20px;
      border: 1px solid #aaa;
      background: none;
      font-size: 16px;
      font-weight: 500;
      border-radius: 4px;
      color: #aaa;
      cursor: pointer;

      h2 {
        font-size: 16px;
      }
    }
    button.active {
      background: #000;
      border: 1px solid #000;
      color: #fff;
      h2 {
        color: #fff;
      }
    }
  }

  /* calendarWrap */
  .calendarContainer input {
    width: 150px;
    background: none;
    border-radius: 4px;
    border: 1px solid #aaa;
    padding: 8px 8px 8px 15px;
    cursor: pointer;
  }
  .weekdatePicker {
    width: 250px !important;
  }
  .calendarContainer button {
    border: none;
  }
  .react-datepicker__day--highlighted {
    background-color: skyblue;
    color: white;
  }
`;
